__turbopack_context__.v({
  "menuContent": "h_k6Ia_menuContent",
});
